// frontend/src/pages/board/components/Feeds/FeedItemComponent.js
import React, { useMemo } from "react";
import WorklogHistory from "./worklogHistory/WorklogHistory";
import ShowComment from "./commentHistory/ShowComment";
import ListFeedHistory from "./feedHistory/ListFeedHistory";

const FeedItemComponent = ({ item, boardName }) => {
  const renderContent = useMemo(() => {
    switch (item.content) {
      case "Worklog_content":
        return <WorklogHistory key={item.id} worklog={{
          ...item,
          work_performed: item.work_performed,
          hour_spent: item.hour_spent,
          allocated_hours: item.allocated_hours,
          workflow_step: item.workflow_step,
          log_type: item.log_type,
        }} boardName={boardName} />;
      case "comment_content":
        return <ListFeedHistory key={item.id} history={item} boardName={boardName} />;
      case "history_content":
        return <ListFeedHistory key={item.id} history={item} boardName={boardName} />;
      default:
        return null;
    }
  }, [item, boardName]);

  return renderContent;
};

export default React.memo(FeedItemComponent);
